/*
 * Module for viewing and changing whether the KB automatically converts backslashes to frontslashes
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "./convertBackslashView",
  "modules/header/kbMenu/kbMenuModel",
], function (Marionette, Backbone, Messenger, ConvertBackslashView, KbMenuModel) {
  var convertBackslashModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "ConvertBackslash";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      //get the property (probably not synced!)
      var currentKb = Messenger.reqres.request("active:kb:model");
      Messenger.onSave(function () {
        console.log("saving convert backslash configuration");
        this.convertBackslashModel.saveModel();
      }, this);

      currentKb.onSynced(function () {
        var convertBackslash = currentKb.get("convertBackslashes");
        var kbId = Messenger.reqres.request("active:kb");
        this.convertBackslashModel = new KbMenuModel.convertBackslash({
          convertBackslash: convertBackslash,
          kbId: kbId,
        });

        this.view = new ConvertBackslashView.convertBackslashView({
          model: this.convertBackslashModel,
        });

        this.view.on(
          "toggle:backslash",
          function () {
            var newValue = !this.convertBackslashModel.get("convertBackslash");
            this.convertBackslashModel.set("convertBackslash", newValue);
            var currentKb = Messenger.reqres.request("active:kb:model");
            currentKb.set("convertBackslashes", newValue);
            this.view.render();
          },
          this,
        );

        this.showRegion(this.view, { loading: false, entity: this.convertBackslashModel });
      }, this);
    },
    _setUpVents: function () {
      //show the module
      Messenger.vent.on(
        "show:kb:admin:convertBackslash",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:kb:profile:convertBackslash",
        function () {
          this.show();
        },
        this,
      );
    },
  });

  return convertBackslashModule;
});
